module.exports = __webpack_public_path__ + "static/media/shopify-dynamic-announcement-bar.661eed14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopify-dynamic-announcement-bar.png
// module id = 393
// module chunks = 0